import { isValid, parse, parseISO } from 'date-fns';

function normalizeDateToLocalDateOnly(raw?: string | null): Date | null {
  if (!raw) return null;
  const value = raw.trim();
  if (!value) return null;

  if (value.includes('T')) {
    const d = parseISO(value);
    if (!isValid(d)) return null;
    const hasTimezone = value.endsWith('Z') || /[+-]\d{2}:\d{2}$/.test(value);
    return hasTimezone
      ? new Date(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate())
      : new Date(d.getFullYear(), d.getMonth(), d.getDate());
  }

  const backend = parse(value, 'yyyy-MM-dd', new Date());
  if (isValid(backend)) return backend;

  return null;
}

export { normalizeDateToLocalDateOnly };
